function parseSaveCurrency(item) {
  return {
    currencySuccess: item.statusCd === "SUCCESS",
  };
}

function parseGetCurrency(item) {
  let currency = null;
  if (item && item.length > 0) currency = item[0].prefRefCcy;

  return {
    currency,
  };
}

function serviceFactory({ api }) {
  const saveCurrency = (currency, metaData) =>
    api.saveCurrency(currency, metaData)
      .then(parseSaveCurrency);

  const getCurrency = (metaData) =>
    api.getCurrency(metaData)
      .then(parseGetCurrency);

  return { saveCurrency, getCurrency };
}

module.exports = serviceFactory;
